export default __webpack_public_path__ + "ddf75bf529e3d303fc8744be4f28b2ae.png";